export const URLS = {
  LANGUAGE_CLOUD_WEBSITE:	"https://languagecloud.sdl.com",
  MEMSOURCE_WEBSITE: "https://www.memsource.com",
  TEXTMASTER_API_INFO: "https://app.textmaster.com/clients/api_info",
  MEMOQ_CLOUD_PAGE: "https://my.memoq.com/memoq-cloud",
}